// Keep the approved button copy local to this draft, not in the app's global settings.
if(typeof boostPFSConfig!=='undefined'&&boostPFSConfig.settings){
 const settings=boostPFSConfig.settings;
 if(settings.label)settings.label.loadMore='Mehr Schmuckstücke anzeigen';
 if(settings.labelTranslations?.de)settings.labelTranslations.de.loadMore='Mehr Schmuckstücke anzeigen';
}
var boostPFS=new BoostPFS();
boostPFS.init();
if(typeof boostPFSConfig!=='undefined'&&boostPFSConfig.general?.isInitFilter&&typeof boostPFSThemeConfig!=='undefined'){
 boostPFS.initFilter();
}
// The relaunch search dialog retains its own accessible predictive UI.
